import './Packs.css';
import {
  rarityNameFor,
  iconURLForRarityId,
  shelterNameForId,
  iconUrlForShelterId,
  imageURLForAsset,
  getMagmicCoinPriceForString,
  nameForSpecialty,
  iconURLForSpecialty,
  titleForShelterId } from '../../shared/assetHelpers';
import { Link, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { ModalContainer } from '../../shared/components/modalContainer/ModalContainer';
import Pet from '../../shared/components/pet/Pet';
import { EndsInCountDownForDate, ResetsInCountDownForDate } from '../../shared/components/CountDownComponents';
import {
  MarketplaceBuyLimitedPetForm,
  MarketplaceBuyRotatingPetForm,
  MarketplaceBuyGachaLotteryForm } from '../../shared/components/transactions/Transactions';

import imageMagmicCoin from './../../images/magmic_coin.png';
import imagePetChest from './../../images/Icon_Chest_06_PET.png';
import imageBackgroundWhiteGraphicsSquareLeft from './../../images/background_white_graphics_square_left_01.png';
import imageBackgroundWhiteGraphicsSquareRight from './../../images/background_white_graphics_square_right_01.png';
import imageBackgroundGeometricSpiralsDarkright from './../../images/body_background_geometric_spirals_dark_01_bottom_right.png';

import { setDataRefreshRequestedDate } from '../../redux/ducks/user';
import { setPetShelterConfig } from '../../redux/ducks/packs';
import { useSelector, useDispatch } from 'react-redux';

import { SignInModal, InsufficientMagmicCoinsModal } from '../../shared/components/user/User';

const amplifyModalId = "AmplifyProviderAuthenticator";

const Packs = () => {

  const history = useHistory();

  const [activeModals, setActiveModals] = useState({}); // add modals as a key/value, where the key is a unique id used to dismiss the modal and the value is what to render

  const [loading, setLocalLoading] = useState(true);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const packsReduxStore = useSelector(state => {
    return state.packs;
  });

  const dispatch = useDispatch();

  const loadPacksPetShelterConfig = () => {
    setLocalLoading(true);
    // Simple GET request
    const requestOptions = {
      method: 'POST'
    };

    if (userReduxStore.braincloudSession && userReduxStore.braincloudSession.sessionId) {
      requestOptions.body = JSON.stringify({
        sessionId: userReduxStore.braincloudSession.sessionId
      })
    }
    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/petshelterconfig";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/petshelterconfig";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
    .then(response => response.json())
    .then(data => {
      setLocalLoading(false);
      dispatch(setPetShelterConfig(data.response && data.response.shelter ? data.response.shelter : []));
    });
  }

  useEffect(
    () => {
      dismissAmplifySignInModal();
      if (userReduxStore.loadComplete) {
        loadPacksPetShelterConfig();
      }
    },
    [userReduxStore.loadComplete] // run on redux user state updates
  );

  const dismissAmplifySignInModal = () => {
    const activeModalsToEdit = activeModals;
    delete activeModalsToEdit[amplifyModalId];
    setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
  };

  const promptToBuyLimitedPet = (limitedPetData) => {

    const isSignedIn = userReduxStore.user && userReduxStore.user.attributes && userReduxStore.user.attributes.email ? true : false;

    if (!isSignedIn) {
      const activeModalsToUpdate = activeModals;

      activeModalsToUpdate[amplifyModalId] = <SignInModal
        title={"Magmic Core Sign In"}
        onDismiss={dismissAmplifySignInModal}
      />;
      setActiveModals({...activeModalsToUpdate});
      return;
    }
  
    if (!userReduxStore.forteData.id) {
      history.push("/wallet/fortelink");
      return;
    }

    const modalId = "marketplacePromptToBuyLimitedPet";
    const bundleId = limitedPetData.id; // "id": "gacha_farmer"
    const bundleName = shelterNameForId(bundleId); // Farmer
    const priceMC = getMagmicCoinPriceForString(limitedPetData.price);

    if (!bundleName || !priceMC) {
      console.error("Packs promptToBuyLimitedPet limitedPetData invalid data or data id or price");
      return;
    }
    if (userReduxStore.magmicCoin === undefined) {
      console.error("Packs promptToBuyLimitedPet userReduxStore missing magmicCoin property");
      return;
    }

    const activeModalsToUpdate = activeModals;
    if (userReduxStore.magmicCoin <= parseInt(limitedPetData.price, 10)) {
      activeModalsToUpdate[modalId] = <InsufficientMagmicCoinsModal
        title={"Buy " + bundleName}
        onDismiss={() => {
          const activeModalsToEdit = activeModals;
          delete activeModalsToEdit[modalId];
          setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
        }}
        assetName={bundleName}
      />
      setActiveModals({...activeModalsToUpdate});
      return;
    }

    const onDismiss = () => {
      const activeModalsToEdit = activeModals;
      delete activeModalsToEdit[modalId];
      setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
    };

    const onSuccess = () => {
      dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user refresh
      loadPacksPetShelterConfig();
      onDismiss();
    };

    activeModalsToUpdate[modalId] = <ModalContainer
      title={"Buy " + bundleName}
      smallPromptFormat={true}
      hideHeaderDismissButton={true}
      onDismiss={onDismiss}
    >
      <MarketplaceBuyLimitedPetForm
        limitedPetData={limitedPetData}
        onDismiss={onDismiss}
        onSuccess={onSuccess}
      />
    </ModalContainer>
    setActiveModals({...activeModalsToUpdate});
  };

  const promptToBuyRotatingPet = (rotatingPetData) => {

    const isSignedIn = userReduxStore.user && userReduxStore.user.attributes && userReduxStore.user.attributes.email ? true : false;

    if (!isSignedIn) {
      const activeModalsToUpdate = activeModals;

      activeModalsToUpdate[amplifyModalId] = <SignInModal
        title={"Magmic Core Sign In"}
        onDismiss={dismissAmplifySignInModal}
      />;
      setActiveModals({...activeModalsToUpdate});
      return;
    }

    if (!userReduxStore.forteData.id) {
      history.push("/wallet/fortelink");
      return;
    }

    const modalId = "marketplacePromptToBuyRotatingPet";
    const bundleName = rotatingPetData.pet ? rotatingPetData.pet.name : undefined;
    const priceMC = getMagmicCoinPriceForString(rotatingPetData.price);

    if (!bundleName || !priceMC) {
      console.error("Packs promptToBuyRotatingPet rotatingPetData invalid data or data id or price");
      return;
    }
    if (userReduxStore.magmicCoin === undefined) {
      console.error("Packs promptToBuyRotatingPet userReduxStore missing magmicCoin property");
      return;
    }

    const activeModalsToUpdate = activeModals;
    if (userReduxStore.magmicCoin <= parseInt(rotatingPetData.price, 10)) {
      activeModalsToUpdate[modalId] = <InsufficientMagmicCoinsModal
        title={"Buy " + bundleName}
        onDismiss={() => {
          const activeModalsToEdit = activeModals;
          delete activeModalsToEdit[modalId];
          setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
        }}
        assetName={bundleName}
      />
      setActiveModals({...activeModalsToUpdate});
      return;
    }

    const onDismiss = () => {
      const activeModalsToEdit = activeModals;
      delete activeModalsToEdit[modalId];
      setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
    };

    const onSuccess = () => {
      dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user refresh
      loadPacksPetShelterConfig();
      onDismiss();
    };

    activeModalsToUpdate[modalId] = <ModalContainer
      title={"Buy " + bundleName}
      smallPromptFormat={true}
      hideHeaderDismissButton={true}
      onDismiss={onDismiss}
    >
      <MarketplaceBuyRotatingPetForm
        rotatingPetData={rotatingPetData}
        onDismiss={onDismiss}
        onSuccess={onSuccess}
      />
    </ModalContainer>
    setActiveModals({...activeModalsToUpdate});
  };

  const promptToBuyGachaLottery = (gachaPetData) => {

    const modalId = "marketplacePromptToBuyGachaLotteryGachaLottery";
    const bundleId = gachaPetData.id; // "id": "gacha_farmer"
    const bundleName = titleForShelterId(bundleId); // Farmer
    const priceMC = getMagmicCoinPriceForString(gachaPetData.price);

    if (!bundleName || !priceMC) {
      console.error("Packs promptToBuyGachaLottery gachaPetData invalid data or data id or price");
      return;
    }

    if (userReduxStore.magmicCoin === undefined) {
      console.error("Packs promptToBuyGachaLottery userReduxStore missing magmicCoin property");
      return;
    }

    const activeModalsToUpdate = activeModals;

    if (userReduxStore.magmicCoin <= parseInt(gachaPetData.price, 10)) {
      activeModalsToUpdate[modalId] = <ModalContainer
        title={"Buy " + bundleName}
        smallPromptFormat={true}
        onDismiss={() => {
          const activeModalsToEdit = activeModals;
          delete activeModalsToEdit[modalId];
          setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
        }}
      >
        <div className="marketplaceModal">
          <p>
            You do not have enough Magmic Coin to purchase {bundleName}.
          </p>
          <p>
            You have <img className="currency" src={imageMagmicCoin} />{userReduxStore.magmicCoin / 1000000000} available.
          </p>
        </div>
      </ModalContainer>
      setActiveModals({...activeModalsToUpdate});
      return;
    }

    const onDismiss = () => {
      const activeModalsToEdit = activeModals;
      delete activeModalsToEdit[modalId];
      setActiveModals({...activeModalsToEdit}); // use spread operator to create a new object
    };

    const onSuccess = () => {
      dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user refresh
      loadPacksPetShelterConfig();
      onDismiss();
    };

    activeModalsToUpdate[modalId] = <ModalContainer
      title={"Buy " + bundleName}
      smallPromptFormat={true}
      hideHeaderDismissButton={true}
      onDismiss={onDismiss}
    >
      <MarketplaceBuyGachaLotteryForm
        gachaPetData={gachaPetData}
        onDismiss={onDismiss}
        onSuccess={onSuccess}
      />
    </ModalContainer>
    setActiveModals({...activeModalsToUpdate});
  };

  
  const petShelters = packsReduxStore.petShelterConfig; // current 'shelter' portion of responses, exclusively.
  const limitedSaleShelters = [];
  const rotatingPetShelters = [];
  const sessionId = userReduxStore.braincloudSession ? userReduxStore.braincloudSession.sessionId : undefined;

  Object.values(petShelters).forEach( (pet, index) => {
    if (!pet.hasOwnProperty("$type")) return;
    if (pet["$type"].includes("ShelterLimitedSale")) {
      limitedSaleShelters.push(pet);
    } else if (pet["$type"].includes("ShelterRotatingPet")) {
      if (!sessionId) {
        rotatingPetShelters.push(pet); // show all to un-authed users
      } else if (pet["buyable"]) {
        rotatingPetShelters.push(pet); // only show buyable to authed users
      }
    }
  });
  /*petShelters.sort((shelterA, shelterB) => {   not required, response is already ordered, where order appears to be a "weight"(?) (highest number should be first)
    if (!shelterA || !shelterA.hasOwnProperty("order")) {
      return 0;
    }
    if (!shelterB || !shelterB.hasOwnProperty("order")) {
      return 0;
    }
    if (shelterA.order >= shelterB.order) {
      return 1;
    }
    return -1;
  });*/

  return (
    <div className="packs">
      {Object.keys(activeModals).map( (modalId) => {
        return activeModals[modalId]
      })}
      <header className="sectionLanding">
        <div className="packsSectionBackgroundLeft"><img src={imageBackgroundWhiteGraphicsSquareLeft} /></div>
        <div className="packsSectionBackgroundRight"><img src={imageBackgroundWhiteGraphicsSquareRight} /></div>
        <div className="sectionLandingContentWrapper">
          <div className="sectionLandingLeft">
            <h1>FEATURED CONTENT</h1>
          </div>
          <div className="sectionLandingRight">
          </div>
        </div>
      </header>
      <div className="sectionSeparator sharp"></div>
      {loading ?
        <div className="sectionWrapper">
          <section className="marketplaceSection">
            <div className="marketplaceResults loadingContainer">
            </div>
          </section>
        </div>
      :
        <div className="sectionWrapper">
          <div className="packsSectionBackgroundRight"><img src={imageBackgroundGeometricSpiralsDarkright} /></div>
          <section className="packsSection">
            {limitedSaleShelters.length ?
              <>
              <header>
                <h2>TIME-LIMITED PETS</h2>
              </header>
              <div className="packsResults">

                {limitedSaleShelters.map( (shelter, index) => {

                  const shelterTypeIconURL = iconUrlForShelterId(shelter.id);

                  let shelterAvailable = false;
                  let shelterQuantity = 0;
                  let shelterRemainQuantity = 0;
                  if (shelter.hasOwnProperty("quantity")) {
                    shelterQuantity = shelter.quantity;
                  }
                  if (shelter.hasOwnProperty("remainQuantity")) {
                    shelterRemainQuantity = shelter.remainQuantity;
                  }
                  if (shelterRemainQuantity > 0) {
                    shelterAvailable = true;
                  }

                  const endDate = new Date(shelter.endSale);
                
                  return (
                    <div className="assetSummary" key={shelter.id}>
                      <div className="assetSummarySeparatorVertical"></div>
                      <div className="assetSummaryContentWrapper">
                        <div className="image chest">
                          <img src={imageURLForAsset(shelter.pet? shelter.pet.visualId.toLowerCase() : "placeholder")}/>
                        </div>
                        <h3 className="title">
                          {shelterTypeIconURL ? <img src={shelterTypeIconURL} className="specialtyIcon" /> : null}
                          {shelterNameForId(shelter.id)}
                        </h3>
                        {shelter.pet && shelter.pet.rarity ?
                          <div className="availability">
                            Rarity: <img src={iconURLForRarityId(shelter.pet.rarity)} className="rarityStars" /> <strong>{rarityNameFor(shelter.pet.rarity)}</strong>
                          </div>
                        :
                          <div className="availability">
                            Rarity: ?
                          </div>
                        }
                        {shelter.pet && shelter.pet.specialty ?
                          <div className="specialties">
                            Specialty:
                              <img src={iconURLForSpecialty(shelter.pet.specialty)} /> <strong>{nameForSpecialty(shelter.pet.specialty)}</strong>
                          </div>
                        :
                          null
                        }
                        <br />
                        <div className="availability">
                          <strong>Available: {shelterRemainQuantity} / {shelterQuantity}</strong>
                        </div>
                        {shelter.endSale ?
                          <>
                          <div className="availability">
                            <strong>End Date: {endDate.toISOString().split("T")[0]}</strong>
                          </div>
                          <div className="availability">
                            <EndsInCountDownForDate countDownDate={endDate} />
                          </div>
                          </>
                        :
                          null
                        }

                        <div className="price">
                          <span className="total">
                            {getMagmicCoinPriceForString(shelter.price)}
                          </span>
                          <span className="currency">&nbsp;<img src={imageMagmicCoin} />&nbsp;</span>
                        </div>
                        <div className="actions">
                          {shelterAvailable ?
                            <button className="buy" onClick={() => {
                              promptToBuyLimitedPet(shelter);
                            }}>
                              Buy
                            </button>
                          :
                            null
                          }
                        </div>
                        {/*<button onClick={(e) => {history.push("/pack/8cbd9291-99d2-4c61-829a-a954c0985c51");}}></button>*/}
                      </div>
                    </div>
                  );
                })}

              </div>
              </>
            :
              null
            }
            {rotatingPetShelters.length ?
              <>
              <header>
                <h2>{rotatingPetShelters.length > 0 ? "ROTATING PETS" : "Check back soon!"}</h2>
              </header>
              <div className="packsResults">

                {rotatingPetShelters.map( (shelter, index) => {
                  let pet = shelter.pet;
                  let priceMC = getMagmicCoinPriceForString(shelter.price);
                  let currentTimestamp = Date.now();
                  let endDate;
                  if (shelter.remainTime) {
                    endDate = new Date(currentTimestamp + shelter.remainTime);
                  }
                  return (
                    <div className="assetSummary" key={shelter.id}>
                        <div className="assetSummarySeparatorVertical"></div>
                        <div className="assetSummaryContentWrapper">
                        <Pet pet={pet} parentComponentExtendedContent={
                          <>
                            <div className="availability">
                              <ResetsInCountDownForDate countDownDate={endDate} />
                            </div>
                            <div className="price">
                              <span className="total">
                                {priceMC}
                              </span>
                              <span className="currency">
                                <img src={imageMagmicCoin} />
                              </span>
                            </div>
                            <div className="actions">
                              <button className="buy" onClick={() => {
                                promptToBuyRotatingPet(shelter);
                              }}>
                                Buy
                              </button>
                            </div>
                          </>
                        }/>
                      </div>
                    </div>
                  )
                })}

              </div>
              </>
            :
              null
            }
          </section>
        </div>
      }
    </div>
  );
}

export default Packs;